<template>
  <v-dialog
  max-width="400px"
  persistent
  v-model="showDialog"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-btn color="accent" flat slot="activator" style="margin-right:-13px;">
      add
    </v-btn>
    <v-card>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="subheading">Add an item to the invoice</span>
          </v-flex>
        </v-layout>
        <v-layout column pt-4>
          <v-flex xs12>
              <v-text-field
                name="description"
                label="Description"
                id="description"
                v-model="addedDescription"
                required
                autofocus
                ref="focus"
                placeholder=" "
                @keyup.enter="onSaveChanges"
                ></v-text-field>
                <v-text-field
                type="number"
                name="amount"
                label="Amount"
                id="amount"
                v-model="addedAmount"
                required
                :prefix="currSymbol"
                placeholder=" "
                @keyup.enter="onSaveChanges"
                ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 style="margin-left:-7px;">
              <v-btn
                depressed
                color="primary"
                @click="showDialog = false">Close</v-btn>
              <v-btn depressed color="accent" @click="onSaveChanges">Add item</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddLineItem',
  data () {
    return {
      showDialog: false,
      addedDescription: '',
      addedAmount: '',
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol
    }
  },
  watch: {
    showDialog (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    }
  },
  methods: {
    onSaveChanges () {
      if (this.addedDescription.trim() === '' || this.addedAmount === '') {
        return
      }
      this.$emit('clicked-show-detail', { description: this.addedDescription, amount: this.addedAmount })
      this.showDialog = false
      this.addedDescription = ''
      this.addedAmount = ''
    }
  }
}
</script>
